export const errorMessages = {
  REQUIRED_FIELD: "This field is required",
  INVALID_PHONE_NUMBER:
    "Invalid phone number. Please enter a valid phone number",
  PHONE_NUMBER_LENGTH: "Phone number must contain at least 4 digits",
  PHONE_NUMBER_MIN_DIGITS: "Phone number must contain at least 4 digits",
  INVALID_EMAIL_OR_PHONE: "Please enter a valid email or phone number",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_PASSWORD:
    "Password must be at least 8 characters and contain uppercase, lowercase, special character and one digit",
  PASSWORD_MISMATCH: "Passwords do not match",
  ERROR_OCCURRED: "An error occurred",
  UNKNOWN_ERROR_OCCURRED: "An unknown error occurred",
  COULD_NOT_FIND_THIS_PAGE: "Could not find this page",
  INVALID_OPTION: "Invalid Option",
  SOMETHING_WENT_WRONG: "Something Went Wrong",
  FAILED_RESET_PASSWORD: "Failed to Reset Password",
  LOGIN_FAILED: "Sign in Failed",
  FAILED_PROFILE_IMAGE_UPLOAD: "Failed To Upload Profile Picture",
  FAILED_GOOGLE_SIGNIN: "An Error Occured While Redirecting to Google",
  INVALID_NUMBER: "Invalid Number",
  INVALID_ID_NUMBER: "Invalid ID format.", // Use GHA-XXXXXXXXX-X.",
  INVALID_DATE: "Invalid Date",
  INVALID_TIME: "Invalid Time",
  SUSPENDED_ACCOUNT:
    "Your account has been suspended. Please contact support for more information.",
  SUSPENDED_TASKER_ACCOUNT:
    "Your service provider account has been suspended. Please contact support for more information.",
  FAILED_BANK_VERIFICATION:
    "Failed to verify bank account. Please check your bank account number and try again.",
  FAILED_MOBILE_MONEY_VERIFICATION:
    "Failed to verify mobile money information. Please check your mobile money payout details and try again.",
  PRIVACY_CONCENT_ERROR: "To proceed, you must accept the Privacy and Policy.",
  INVALID_CURRENCY: "Currency value must be greater than 0",
  INVALID_FIRST_NAME: "First name should only contain letters and spaces",
  INVALID_LAST_NAME: "Last name should only contain letters and spaces",
  INVALID_FULL_NAME: "Name should only contain letters and spaces",
  MAX_LENGTH_EXCEEDED: "Maximum length exceeded",
  JOB_TITLE_MAX_LENGTH: "Job title must not exceed 50 characters",
  INVALID_JOB_TITLE: "Job title should only contain letters and spaces",
  INVALID_ORG_NAME: "Organization name should only contain letters and spaces",
  INVALID_URL:
    "Please enter a valid URL (e.g.,https://linkedin.com/in/username)",
};
